import {
  CMS_API
} from '../config';

export type LogKind = 'info' | 'debug' | 'error';

export type LogData = {
  type: string;
  kind: LogKind;
  payload: unknown;
  user?: unknown;
}

export const reportLog = async (sessionKey: string, log: LogData): Promise<void> => {
  try {
    const url = `${CMS_API}/api/logs?sessionKey=${sessionKey}`;

    const body = JSON.stringify({
      type: log.type,
      kind: log.kind,
      payload: log.payload,
      user: log.user,
    });

    const response = await fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body });

    if (!response.ok) console.warn('🚨 Failed to send log', await response.text());
    else console.log('✅ Log sent successfully');

  } catch (err) {
    console.error('❌ Error sending log:', err);
  }
}
